(() => {
  function init(scope) {
    scope.querySelectorAll('.unico-gallery__main, [data-gallery-main]').forEach(gallery => {
      if (gallery.dataset.warmupReady) return;
      gallery.dataset.warmupReady = 'true';
      let scheduled = false;
      let observer;
      const warm = () => {
        scheduled = false;
        const panels = [...gallery.querySelectorAll(':scope > [data-media-panel]')];
        const index = panels.findIndex(panel => !panel.hidden);
        if (index < 0) return;
        const activeImages = [...panels[index].querySelectorAll('img[src]')];
        activeImages.forEach(image => {
          image.fetchPriority = 'high';
          image.loading = 'eager';
        });
        const next = () => {
          // Respect reduced-data and slow mobile connections: do not fetch
          // off-screen gallery panels until the visitor asks for them.
          const connection = navigator.connection;
          if (connection?.saveData || /^(slow-2g|2g|3g)$/.test(connection?.effectiveType || '')) return;
          const previewCount = connection ? 1 : 2;
          for (const panel of panels.slice(index + 1, index + 1 + previewCount)) {
            window.UnicoImages?.reveal(panel, true);
            panel.querySelectorAll('img[src]').forEach(image => {
              if (image.loading === 'eager') return;
              image.fetchPriority = 'low';
              image.decoding = 'async';
              image.loading = 'eager';
            });
          }
        };
        const ready = Promise.all(activeImages.map(image => image.decode().catch(() => {})));
        ready.then(() => {
          if (panels[index].hidden) return;
          if (index > 0) next();
          else if ('requestIdleCallback' in window) requestIdleCallback(next, {timeout:1200});
          else setTimeout(next, 100);
        });
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(warm);
      };
      observer = new MutationObserver(schedule);
      observer.observe(gallery,{subtree:true,attributes:true,attributeFilter:['hidden']});
      if ('IntersectionObserver' in window) {
        const visibility = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            schedule();
            visibility.disconnect();
          }
        });
        visibility.observe(gallery);
      } else schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

